/*
 * Where the firm calendar lives.
 *
 *   /calendar                   the firm calendar (month by default)
 *   /calendar?date=YYYY-MM-DD&view=day   a specific day
 *
 * No React or IO here so the rules stay unit-testable.
 */
import dayjs from "dayjs";
import { matchPath } from "react-router-dom";

import type { CalendarView } from "./calendarModel";

export const CALENDAR_PATH = "/calendar";

export const isCalendarPath = (pathname: string): boolean =>
  matchPath({ path: CALENDAR_PATH, end: true }, pathname) !== null;

/** Link into the firm calendar, optionally landing on a day and view. */
export const calendarPathFor = (
  date?: Date | string | null,
  view?: CalendarView
): string => {
  const params = new URLSearchParams();
  if (date) {
    const d = dayjs(date);
    if (d.isValid()) params.set("date", d.format("YYYY-MM-DD"));
  }
  if (view) params.set("view", view);
  const qs = params.toString();
  return qs ? `${CALENDAR_PATH}?${qs}` : CALENDAR_PATH;
};
